module.exports = __webpack_public_path__ + "img/hb0t4.bf5a62fc.png";